// components/ContinuesTrainings.jsx
import axios from "axios";
import React, { useEffect, useState } from "react";

const ContinuesTrainings = () => {
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingTraining, setEditingTraining] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    title_ar: "",
    groups: "",
    trainers: "",
  });
  const [trainings, setTrainings] = useState([]);
  const [flag, setFlag] = useState(false);
  // Handle Add/Edit Form Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isEditing && editingTraining) {
      // Update existing training
      await axios.patch(
        process.env.REACT_APP_BASE_URL +
          "continues-training/update-continues-training",
        null,
        {
          params: {
            training_id: editingTraining.id,
            ...formData,
          },
        }
      );
      setFlag(!flag);
    } else {
      await axios.post(
        process.env.REACT_APP_BASE_URL +
          "continues-training/add-continues-training",
        formData
      );
      setFlag(!flag);
    }

    resetForm();
  };

  // Handle Edit
  const handleEdit = (training) => {
    setFormData({
      title: training.title,
      title_ar: training.title_ar,
      groups: training.groups.toString(),
      trainers: training.trainers.toString(),
    });
    setEditingTraining(training);
    setIsEditing(true);
    setIsAdding(true);
  };

  // Handle Delete
  const handleDelete = async (trainingId) => {
    // setTrainings(trainings.filter((t) => t.id !== trainingId));
    await axios.delete(
      process.env.REACT_APP_BASE_URL +
        "continues-training/delete-continues-training",
      {
        params: {
          training_id: trainingId,
        },
      }
    );
    setFlag(!flag);
  };

  // Reset form and states
  const resetForm = () => {
    setFormData({ title: "", groups: "", trainers: "" });
    setIsAdding(false);
    setIsEditing(false);
    setEditingTraining(null);
  };

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle cancel
  const handleCancel = () => {
    resetForm();
  };

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_BASE_URL +
          "continues-training/get-allcontinues-trainings"
      )
      .then((res) => {
        // console.log(res.data.data);
        setTrainings(res.data.data);
      });
  }, [flag]);

  return (
    <div className="space-y-8">
      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Total Trainings</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {trainings.length}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">📚</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Total Groups</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {trainings.reduce((sum, t) => sum + t.groups, 0)}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">👥</span>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 transform hover:scale-105 transition-all duration-300 border-l-4 border-green-500">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-gray-600 text-sm">Total Trainers</p>
              <p className="text-3xl font-bold text-gray-800 mt-2">
                {trainings.reduce((sum, t) => sum + t.trainers, 0)}
              </p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <span className="text-green-600 text-xl">👨‍🏫</span>
            </div>
          </div>
        </div>
      </div>

      {/* Header with Add Button */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-gray-800">
            Training Programs
          </h2>
          <p className="text-gray-600 mt-1">
            Manage your continuous training programs
          </p>
        </div>
        <button
          onClick={() => setIsAdding(true)}
          className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center space-x-2 group"
        >
          <span className="group-hover:scale-110 transition-transform duration-200">
            +
          </span>
          <span>Add Training</span>
        </button>
      </div>

      {/* Add/Edit Training Form Modal */}
      {isAdding && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md transform animate-scale-in">
            <div className="p-6 border-b border-green-200 bg-gradient-to-r from-green-50 to-green-100 rounded-t-2xl">
              <h3 className="text-xl font-bold text-gray-800">
                {isEditing ? "Edit Training" : "Add New Training"}
              </h3>
              <p className="text-green-600 text-sm mt-1">
                {isEditing
                  ? "Update the training details"
                  : "Create a new training program"}
              </p>
            </div>
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Title *
                </label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter training title"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Title Arabic*
                </label>
                <input
                  type="text"
                  name="title_ar"
                  value={formData.title_ar}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  placeholder="Enter training title Arabic"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Groups *
                  </label>
                  <input
                    type="number"
                    name="groups"
                    value={formData.groups}
                    onChange={handleChange}
                    required
                    min="1"
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                    placeholder="0"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Trainers *
                  </label>
                  <input
                    type="number"
                    name="trainers"
                    value={formData.trainers}
                    onChange={handleChange}
                    required
                    min="1"
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                    placeholder="0"
                  />
                </div>
              </div>

              <div className="flex space-x-3 pt-4">
                <button
                  type="submit"
                  className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
                >
                  {isEditing ? "Update Training" : "Add Training"}
                </button>
                <button
                  type="button"
                  onClick={handleCancel}
                  className="flex-1 bg-gray-300 text-gray-700 py-3 rounded-xl font-semibold hover:bg-gray-400 transition-colors duration-200"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Trainings List */}
      <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
        {trainings.length === 0 ? (
          <div className="text-center py-16">
            <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-4xl">📚</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-700 mb-2">
              No trainings yet
            </h3>
            <p className="text-gray-500 mb-6">
              Start by adding your first training program
            </p>
            <button
              onClick={() => setIsAdding(true)}
              className="bg-gradient-to-r from-green-500 to-green-600 text-white px-6 py-3 rounded-xl font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              Add First Training
            </button>
          </div>
        ) : (
          <div className="divide-y divide-gray-200">
            {trainings.map((training, index) => (
              <div
                key={training.id}
                className="p-6 hover:bg-green-50 transition-all duration-200 group"
                style={{
                  animationDelay: `${index * 100}ms`,
                  animation: "slideIn 0.3s ease-out",
                }}
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h4 className="text-lg font-semibold text-gray-800 mb-2 group-hover:text-green-700 transition-colors duration-200">
                      {training.title}
                    </h4>
                    <div className="flex space-x-6 text-sm text-gray-600">
                      <span className="flex items-center space-x-2 bg-green-100 px-3 py-1 rounded-full">
                        <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                        <span className="font-medium">
                          {training.groups} Groups
                        </span>
                      </span>
                      <span className="flex items-center space-x-2 bg-blue-100 px-3 py-1 rounded-full">
                        <span className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></span>
                        <span className="font-medium">
                          {training.trainers} Trainers
                        </span>
                      </span>
                      <span className="flex items-center space-x-2 bg-purple-100 px-3 py-1 rounded-full">
                        <span className="w-2 h-2 bg-purple-500 rounded-full animate-pulse"></span>
                        <span className="font-medium">
                          {training.groups * training.trainers} Total
                          Participants
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="flex space-x-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    <button
                      onClick={() => handleEdit(training)}
                      className="w-10 h-10 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center hover:bg-blue-200 transition-all duration-200 transform hover:scale-110 shadow-sm"
                      title="Edit Training"
                    >
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        />
                      </svg>
                    </button>
                    <button
                      onClick={() => handleDelete(training.id)}
                      className="w-10 h-10 bg-red-100 text-red-600 rounded-full flex items-center justify-center hover:bg-red-200 transition-all duration-200 transform hover:scale-110 shadow-sm"
                      title="Delete Training"
                    >
                      <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Quick Stats Footer */}
      {trainings.length > 0 && (
        <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-2xl p-6 text-white">
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <p className="text-sm opacity-90">Active Programs</p>
              <p className="text-2xl font-bold">{trainings.length}</p>
            </div>
            <div>
              <p className="text-sm opacity-90">Total Capacity</p>
              <p className="text-2xl font-bold">
                {trainings.reduce((sum, t) => sum + t.groups * t.trainers, 0)}
              </p>
            </div>
            <div>
              <p className="text-sm opacity-90">Avg. Trainers/Program</p>
              <p className="text-2xl font-bold">
                {(
                  trainings.reduce((sum, t) => sum + t.trainers, 0) /
                  trainings.length
                ).toFixed(1)}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContinuesTrainings;
